// MAROVAR — scripts de marca (vanilla, sin librerias)

function mvInitReveals() {
  var els = document.querySelectorAll('.mv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function mvInitContadores() {
  var els = document.querySelectorAll('[data-mv-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-mv-contador'));
      var decimales = el.getAttribute('data-mv-decimales') === '1' ? 1 : 0;
      var duracion = 1600;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var ease = 1 - Math.pow(1 - progreso, 3);
        el.textContent = (fin * ease).toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

// Carrusel de opiniones: pista con scroll nativo (se desliza con el dedo en
// móvil y con las flechas en escritorio). La barra indica la posición.
function mvInitResenasCarrusel() {
  var wraps = document.querySelectorAll('[data-mv-resenas]');
  wraps.forEach(function (wrap) {
    var pista = wrap.querySelector('[data-mv-pista]');
    if (!pista) return;
    var tarjetas = pista.querySelectorAll('[data-mv-tarjeta]');
    if (!tarjetas.length) return;

    var prev = wrap.querySelector('[data-mv-prev]');
    var next = wrap.querySelector('[data-mv-next]');
    var progreso = wrap.querySelector('[data-mv-progreso]');

    function paso() {
      var t = tarjetas[0];
      var estilo = window.getComputedStyle(pista);
      var hueco = parseFloat(estilo.columnGap || estilo.gap || '20') || 20;
      return t.getBoundingClientRect().width + hueco;
    }

    function maximo() {
      return Math.max(pista.scrollWidth - pista.clientWidth, 0);
    }

    function actualizar() {
      var max = maximo();
      var x = pista.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (progreso) {
        var visible = Math.min(pista.clientWidth / pista.scrollWidth, 1);
        var ancho = Math.max(visible * 100, 8);
        var izq = max > 0 ? (x / max) * (100 - ancho) : 0;
        progreso.style.width = ancho + '%';
        progreso.style.left = izq + '%';
      }
    }

    function mover(direccion) {
      // Avanzar de tarjeta en tarjeta, o de bloque visible si caben varias
      var visibles = Math.max(Math.floor(pista.clientWidth / paso()), 1);
      pista.scrollBy({ left: direccion * paso() * visibles, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { mover(-1); });
    if (next) next.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();

    // Arrastrar con el ratón en escritorio
    var arrastrando = false, inicioX = 0, inicioScroll = 0;
    pista.addEventListener('mousedown', function (e) {
      arrastrando = true; inicioX = e.pageX; inicioScroll = pista.scrollLeft;
      pista.style.cursor = 'grabbing';
    });
    window.addEventListener('mouseup', function () {
      arrastrando = false; pista.style.cursor = '';
    });
    pista.addEventListener('mousemove', function (e) {
      if (!arrastrando) return;
      e.preventDefault();
      pista.scrollLeft = inicioScroll - (e.pageX - inicioX);
    });
  });
}

// Galería del producto: pista con scroll nativo y encaje por foto. Se desliza
// con el dedo en móvil; flechas, miniaturas y teclado en escritorio. Expone
// galeria.mvIr(indice) para que el cambio de color lleve a su foto.
function mvInitGaleriaProducto() {
  document.querySelectorAll('[data-mv-galeria-producto]').forEach(function (galeria) {
    var pista = galeria.querySelector('[data-mv-pista-galeria]');
    if (!pista) return;
    var slides = pista.querySelectorAll('[data-mv-slide]');
    var minis = galeria.querySelectorAll('[data-mv-mini]');
    var puntos = galeria.querySelectorAll('[data-mv-punto]');
    var prev = galeria.querySelector('[data-mv-galeria-prev]');
    var next = galeria.querySelector('[data-mv-galeria-next]');
    var contador = galeria.querySelector('[data-mv-galeria-contador]');
    var actual = 0;

    function indiceVisible() {
      return Math.round(pista.scrollLeft / Math.max(pista.clientWidth, 1));
    }
    function marcar(i) {
      actual = Math.max(0, Math.min(i, slides.length - 1));
      minis.forEach(function (m, j) { m.classList.toggle('mv-activo', j === actual); });
      puntos.forEach(function (p, j) { p.classList.toggle('mv-activo', j === actual); });
      if (contador) contador.textContent = (actual + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = actual === 0;
      if (next) next.disabled = actual === slides.length - 1;
      // La miniatura activa, siempre a la vista.
      var mini = minis[actual];
      if (mini && mini.parentElement) {
        var fila = mini.parentElement;
        var izq = mini.offsetLeft - fila.offsetLeft;
        if (izq < fila.scrollLeft || izq + mini.offsetWidth > fila.scrollLeft + fila.clientWidth) {
          fila.scrollTo({ left: izq - 8, behavior: 'smooth' });
        }
      }
    }
    function ir(i, suave) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      pista.scrollTo({ left: i * pista.clientWidth, behavior: suave === false ? 'instant' : 'smooth' });
      marcar(i);
    }
    galeria.mvIr = ir;
    galeria.mvIrAMedia = function (mediaId) {
      for (var k = 0; k < slides.length; k++) {
        if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { ir(k, false); return; }
      }
    };

    // Precarga: todas las fotos se piden ya, para que el cambio de color sea
    // instantáneo y no salga primero la foto anterior.
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      img.loading = 'eager';
      img.decoding = 'async';
      var pre = new Image();
      pre.srcset = img.srcset; pre.sizes = img.sizes; pre.src = img.currentSrc || img.src;
    });

    var espera;
    pista.addEventListener('scroll', function () {
      clearTimeout(espera);
      espera = setTimeout(function () { marcar(indiceVisible()); }, 60);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (next) next.addEventListener('click', function () { ir(actual + 1); });
    minis.forEach(function (m, j) { m.addEventListener('click', function () { ir(j); }); });
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(actual + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); ir(actual - 1); }
    });
    window.addEventListener('resize', function () { ir(actual, false); });
    marcar(0);
  });
}

// Fechas de entrega estimada: hoy + N días hábiles (sin sábados ni domingos).
function mvInitEntrega() {
  document.querySelectorAll('[data-mv-entrega]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 10;
    var max = parseInt(el.getAttribute('data-max'), 10) || 15;
    function sumarHabiles(dias) {
      var d = new Date();
      while (dias > 0) {
        d.setDate(d.getDate() + 1);
        var s = d.getDay();
        if (s !== 0 && s !== 6) dias--;
      }
      return d;
    }
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function fmt(d) { return d.getDate() + ' ' + meses[d.getMonth()]; }
    var destino = el.querySelector('[data-mv-entrega-fechas]');
    if (!destino) return;
    destino.textContent = 'del ' + fmt(sumarHabiles(min)) + ' al ' + fmt(sumarHabiles(max));
    el.hidden = false;
  });
}

function mvInitVariantes() {
  var forms = document.querySelectorAll('[data-mv-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mv-variantes-json]');
    var selects = form.querySelectorAll('[data-mv-opcion]');
    if (!dataEl || !selects.length) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function variantesActuales() {
      var valores = [];
      selects.forEach(function (s) { valores.push(s.value); });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      var variante = variantesActuales();
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-mv-precio]');
      var compareEl = form.querySelector('[data-mv-precio-comparado]');
      var boton = form.querySelector('[data-mv-boton-comprar]');
      if (!variante) {
        if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-texto-agotado') || 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variante.id;
      var etiquetaValor = form.querySelector('[data-mv-opcion-valor]');
      if (etiquetaValor && selects.length === 1) etiquetaValor.textContent = selects[0].value;
      // Al elegir un color, la galería se desliza hasta la foto de ese color.
      if (variante.media_id) {
        var seccion = form.closest('.mv-producto');
        var galeria = seccion && seccion.querySelector('[data-mv-galeria-producto]');
        if (galeria && galeria.mvIrAMedia) galeria.mvIrAMedia(variante.media_id);
      }
      if (precioEl) precioEl.textContent = mvFormatoDinero(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = mvFormatoDinero(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (boton) {
        if (variante.available) {
          boton.disabled = false;
          boton.textContent = boton.getAttribute('data-texto-comprar') || boton.textContent;
        } else {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

// Círculos de color: pulsar uno cambia el desplegable oculto (que es el que
// manda) y dispara el cambio de variante de siempre.
function mvInitColores() {
  document.querySelectorAll('[data-mv-color]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var opcion = boton.closest('.mv-producto__opcion');
      if (!opcion) return;
      var select = opcion.querySelector('[data-mv-opcion]');
      var valor = boton.getAttribute('data-mv-color');
      opcion.querySelectorAll('[data-mv-color]').forEach(function (b) {
        var activo = b === boton;
        b.classList.toggle('mv-activo', activo);
        b.setAttribute('aria-checked', activo ? 'true' : 'false');
      });
      var etiqueta = opcion.querySelector('[data-mv-opcion-valor]');
      if (etiqueta) etiqueta.textContent = valor;
      if (select) {
        select.value = valor;
        select.dispatchEvent(new Event('change'));
      }
    });
  });
}

// Packs 1 / 2 unidades. El descuento real lo aplica Shopify (descuento
// automático con el mismo porcentaje); aquí solo se muestra y se fija la cantidad.
function mvInitPacks() {
  document.querySelectorAll('[data-mv-form-producto]').forEach(function (form) {
    var seccion = form.closest('[data-mv-producto]');
    var packs = form.querySelector('[data-mv-packs]');
    var cantidad = form.querySelector('[data-mv-cantidad]');
    var dataEl = form.querySelector('[data-mv-variantes-json]');
    var idInput = form.querySelector('input[name="id"]');
    var barraPrecio = seccion && seccion.querySelector('[data-mv-barra-precio]');
    var variantes = [];
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) {}

    function varianteActual() {
      var id = idInput ? parseInt(idInput.value, 10) : null;
      return variantes.find(function (v) { return v.id === id; }) || variantes[0];
    }

    function refrescar() {
      var v = varianteActual();
      if (!v) return;
      var n = cantidad ? parseInt(cantidad.value, 10) || 1 : 1;
      var ahorro = packs ? parseInt(packs.getAttribute('data-ahorro'), 10) || 0 : 0;
      var total2 = v.price * 2;
      // Igual que Shopify en la caja: importe fijo de descuento sobre el pack.
      var precio2 = total2 - ahorro;
      if (packs) {
        var p1 = packs.querySelector('[data-mv-pack-precio="1"]');
        var p2 = packs.querySelector('[data-mv-pack-precio="2"]');
        var t2 = packs.querySelector('[data-mv-pack-tachado]');
        if (p1) p1.textContent = mvFormatoDinero(v.price);
        if (p2) p2.textContent = mvFormatoDinero(precio2);
        if (t2) t2.textContent = mvFormatoDinero(total2);
      }
      if (barraPrecio) barraPrecio.textContent = mvFormatoDinero(n === 2 ? precio2 : v.price) + (n === 2 ? ' · 2 uds' : '');
    }

    if (packs) {
      packs.querySelectorAll('[data-mv-pack]').forEach(function (b) {
        b.addEventListener('click', function () {
          packs.querySelectorAll('[data-mv-pack]').forEach(function (x) {
            var activo = x === b;
            x.classList.toggle('mv-activo', activo);
            x.setAttribute('aria-checked', activo ? 'true' : 'false');
          });
          if (cantidad) cantidad.value = b.getAttribute('data-mv-pack');
          refrescar();
        });
      });
    }
    form.querySelectorAll('[data-mv-opcion]').forEach(function (s) {
      s.addEventListener('change', function () { setTimeout(refrescar, 0); });
    });
    refrescar();

    // Barra fija: se muestra cuando el botón principal ya no se ve.
    var barra = seccion && seccion.querySelector('[data-mv-barra-compra]');
    var principal = form.querySelector('[data-mv-boton-comprar]');
    if (barra && principal && 'IntersectionObserver' in window) {
      var botonBarra = barra.querySelector('[data-mv-barra-boton]');
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var mostrar = !en.isIntersecting && en.boundingClientRect.top < 0;
          barra.classList.toggle('mv-visible', mostrar);
          barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
          if (botonBarra) botonBarra.tabIndex = mostrar ? 0 : -1;
        });
      });
      obs.observe(principal);
      if (botonBarra) botonBarra.addEventListener('click', function () {
        if (principal.disabled) return;
        if (form.requestSubmit) form.requestSubmit(principal); else principal.click();
      });
    }
  });
}

function mvFormatoDinero(centavos) {
  var valor = (centavos / 100).toFixed(2).replace('.', ',');
  return valor + ' €';
}

// El cajón del menú móvil de Dawn no se cierra solo al pulsar un enlace.
// Lo cerramos nosotros: en enlaces de ancla (#) y también al navegar,
// para que no quede abierto al volver atrás.
function mvInitCierreMenu() {
  var contenedor = document.querySelector('#Details-menu-drawer-container');
  if (!contenedor) return;

  var velo = null;

  function quitarVelo() {
    if (!velo) return;
    var v = velo;
    velo = null;
    v.classList.remove('mv-velo--visible');
    setTimeout(function () {
      if (v && v.parentNode) v.parentNode.removeChild(v);
    }, 380);
  }

  function ponerVelo() {
    if (velo || window.innerWidth >= 990) return;
    velo = document.createElement('div');
    velo.className = 'mv-velo';
    velo.setAttribute('aria-hidden', 'true');
    velo.addEventListener('click', cerrar);
    document.body.appendChild(velo);
    // Forzar un reflow para que la transición de opacidad se vea
    void velo.offsetWidth;
    velo.classList.add('mv-velo--visible');
  }

  function cerrar() {
    if (!contenedor.hasAttribute('open')) {
      quitarVelo();
      return;
    }
    var componente = document.querySelector('header-drawer');
    // Ruta preferida: el propio componente de Dawn (restaura el scroll del body)
    if (componente && typeof componente.close === 'function') {
      componente.close();
    } else {
      contenedor.removeAttribute('open');
      var resumen = contenedor.querySelector('summary');
      if (resumen) resumen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
    }
    quitarVelo();
  }

  // Sincronizar el velo con el estado real del cajón
  var observador = new MutationObserver(function () {
    if (contenedor.hasAttribute('open')) ponerVelo();
    else quitarVelo();
  });
  observador.observe(contenedor, { attributes: true, attributeFilter: ['open'] });

  // Cerrar al pulsar cualquier enlace del menú
  contenedor.addEventListener('click', function (evento) {
    if (evento.target.closest('a[href]')) setTimeout(cerrar, 80);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) quitarVelo();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mvInitCierreMenu();
  mvInitReveals();
  mvInitContadores();
  mvInitResenasCarrusel();
  mvInitGaleriaProducto();
  mvInitVariantes();
  mvInitColores();
  mvInitPacks();
  mvInitEntrega();
});
